import { lazyImageStyles, lazyLoadStyles } from "@store/theme/common/mixins";
import styled, { css } from "styled-components";

export const LazyImagePlaceholder = styled.span`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    ${lazyLoadStyles()}
`;

export default {
    defaultProps: {
        css: css`
            ${lazyImageStyles()}
        `,
    },
};
